module.exports = __webpack_public_path__ + "img/shebao.d228ed86.png";